import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#cky65bbm2__clip0_small)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#epno0w7oz__clip1_small)",
          children: [_jsxs("g", {
            transform: "translate(-6.5 0)",
            children: [_jsx("rect", {
              x: "0",
              y: "0",
              width: "33",
              height: "6.667",
              fill: "#239F40"
            }), _jsx("rect", {
              x: "0",
              y: "6.667",
              width: "33",
              height: "6.667",
              fill: "#FFFFFF"
            }), _jsx("rect", {
              x: "0",
              y: "13.333",
              width: "33",
              height: "6.667",
              fill: "#DA0000"
            })]
          }), _jsxs("g", {
            fill: "#DA0000",
            transform: "matrix(1.8,0,0,1.8,10,10)",
            children: [_jsxs("g", {
              id: "l50642qo7__emblem_half_fa",
              children: [_jsx("path", {
                d: "M 1.015679,-0.01556 A 0.77528237,0.7752862 0 0 1 0.60199011,0.67052066 1.0040699,1.0040749 0 0 0 0.44435035,-0.74067818 q -0.0221518,-0.0177005 -0.0452767,-0.0341288 A 0.77575926,0.7757631 0 0 1 1.015679,-0.01556 Z"
              }), _jsx("path", {
                d: "m 0.65590144,-0.04683837 a 0.92689013,0.92689472 0 0 1 -1.21301321,0.88105983 q 0.0245198,0.00118 0.0492749,0.001178 a 1.0158759,1.0158809 0 0 0 0.84183925,-1.58419413 0.92423346,0.92423804 0 0 1 0.32189906,0.7019563 z"
              }), _jsx("path", {
                d: "M 0.26154437,-0.94393072 A 0.14154065,0.14154135 0 0 1 1.7299476e-6,-0.86887791 L -0.01707249,-0.88602911 1.7299476e-6,-0.96931462 A 0.1321491,0.13214975 0 0 0 0.24983482,-1.0002001 a 0.14021999,0.14022068 0 0 1 0.0117096,0.0562694 z"
              }), _jsx("path", {
                d: "M 0.11992727,-0.71445117 A 0.31475286,0.31475442 0 0 1 1.2855032e-6,-0.81025163 L -0.0506876,-0.01642556 1.2855032e-6,1.0001998 0.07882572,0.89166862 0.0891995,0.64144186 0.09996594,0.3809197 l 0.0014156,-0.0334002 4.7111e-4,-0.0124172 0.002279,-0.0541474 0.006758,-0.1640148 0.005501,-0.13242286 0.001571,-0.03827263 0.002042,-0.04872535 V -0.71445117 Z M 1.2855032e-6,-0.54965037 9.0174383e-5,-0.54949481 1.2855032e-6,-0.54933925 Z m 0,0.86447753 V 0.3145916 L 3.946188e-4,0.31468049 Z"
              })]
            }), _jsx("use", {
              href: "#l50642qo7__emblem_half_fa",
              transform: "scale(-1,1)"
            })]
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "cky65bbm2__clip0_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "epno0w7oz__clip1_small",
          children: _jsx("rect", {
            width: "33",
            height: "20",
            fill: "white",
            transform: "translate(-6.5)"
          })
        })]
      })]
    }))
  });
};
export default Component;
